import React, { useState } from 'react';
import { ClientsTable } from '../components/clients/ClientsTable';
import { Card } from '../components/ui/Card';
import { SearchIcon, FilterIcon, DownloadIcon, PlusIcon } from 'lucide-react';
export function Clienti() {
  const [searchTerm, setSearchTerm] = useState('');
  return <div className="space-y-6 pb-16" data-id="element-2013">
      <div data-id="element-2014">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2015">Clienti</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2016">
          Gestisci e monitora i tuoi clienti e il loro stato di pagamento.
        </p>
      </div>
      <Card data-id="element-2017">
        <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-between mb-4" data-id="element-2018">
          <div className="relative flex-1 max-w-md" data-id="element-2019">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2020">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-2021" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-[#1A3E5C] focus:border-[#1A3E5C] sm:text-sm" placeholder="Cerca per ragione sociale, P.IVA..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2022" />
          </div>
          <div className="flex space-x-2" data-id="element-2023">
            <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-2024">
              <FilterIcon className="h-4 w-4 mr-2" data-id="element-2025" />
              Filtri
            </button>
            <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-2026">
              <DownloadIcon className="h-4 w-4 mr-2" data-id="element-2027" />
              Esporta
            </button>
            <button className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-[#1A3E5C] hover:bg-[#15324a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-2028">
              <PlusIcon className="h-4 w-4 mr-2" data-id="element-2029" />
              Nuovo Cliente
            </button>
          </div>
        </div>
        <ClientsTable searchTerm={searchTerm} data-id="element-2030" />
      </Card>
    </div>;
}